module.exports = __webpack_public_path__ + "static/media/total-done.60987d76.svg";